


















import { Component, Vue } from "vue-property-decorator";
import { FormSelect } from "../forms/parts";

@Component({
    components: {
        VacancyCard: () => import("./vacancy-card.vue"),
        FormSelect
    }
})
export default class VacanciesFilter extends Vue {
    loading: boolean = false;

    params: any = { per_page: 99, page: 1 };

    vacancies: JobToolzVacancy[] = [];

    sector: string = "";

    location: string = "";

    job: string = "";

    minHeigh = 1070;

    private async mounted() {
        await this.getVacancies();

        const params = new URLSearchParams(window.location.search);
        if (params.has("dienst")) {
            const sector = params.get("dienst");
            if (sector) {
                // @ts-ignore
                const match = this.sectorOptions.find((val: string) => this.slugify(val) === this.slugify(sector));
                if (match) {
                    this.sector = match;
                }
            }
        }

        if (params.has("locatie")) {
            const location = params.get("locatie");

            if (location) {
                // @ts-ignore
                const match = this.locationOptions.find((val: string) => this.slugify(val) === this.slugify(location));
                if (match) {
                    this.location = match;
                }
            }
        }

        if (params.has("functie")) {
            const job = params.get("functie");
            if (job) {
                // @ts-ignore
                const match = this.jobOptions.find((val: string) => this.slugify(val) === this.slugify(job));
                if (match) {
                    this.job = match;
                }
            }
        }
    }

    private slugify(text: string) {
        return text
            .normalize("NFKD")
            .toLowerCase()
            .replace(/[^\w\s-]/g, "")
            .trim()
            .replace(/[-\s]+/g, "-");
    }

    private getVacancies() {
        this.loading = true;

        // @ts-ignore
        return axios
            .get("/api/jobtoolz/jobs", { params: { ...this.params } })
            .then((response: any) => {
                this.vacancies = response.data;

                // @ts-ignore
                let comp = this.$root.$children.find(c => c.$vnode.componentOptions.tag === "section-floating-cards");
                if (comp) {
                    this.$nextTick(() => {
                        // @ts-ignore
                        comp.init();
                    });
                }
            })
            .finally(() => (this.loading = false));
    }

    get localVacancies() {
        return this.vacancies.filter((vacancy: JobToolzVacancy) => {
            let sectorCheck = true;
            if (this.sector) {
                sectorCheck = (vacancy.filter_groups?.Dienst ?? []).includes(this.sector);
            }

            let locationCheck = true;
            if (this.location) {
                locationCheck = (vacancy.filter_groups?.Locatie ?? []).includes(this.location);
            }

            let jobCheck = true;
            if (this.job) {
                jobCheck = (vacancy.filter_groups?.Functie ?? []).includes(this.job);
            }

            return sectorCheck && locationCheck && jobCheck;
        });
    }

    get sectorOptions(): string[] {
        return [
            ...new Set(
                this.localVacancies.map((v: JobToolzVacancy) => {
                    if (!v.filter_groups?.Dienst) {
                        return null;
                    }

                    return v.filter_groups?.Dienst[0];
                })
            )
        ].filter(Boolean) as string[];
    }

    get jobOptions(): string[] {
        return [
            ...new Set(
                this.localVacancies.map((v: JobToolzVacancy) => {
                    if (!v.filter_groups?.Functie) {
                        return null;
                    }

                    return v.filter_groups?.Functie[0];
                })
            )
        ].filter(Boolean) as string[];
    }

    get locationOptions(): string[] {
        return [
            ...new Set(
                this.localVacancies.map((v: JobToolzVacancy) => {
                    if (!v.filter_groups?.Locatie) {
                        return null;
                    }

                    return v.filter_groups?.Locatie[0];
                })
            )
        ].filter(Boolean) as string[];
    }
}
